
import { FC } from "react"
import { Box, TextField } from "@mui/material"
import { ErrorOutline } from "@mui/icons-material";

interface EditTextFieldProps {
    require?: boolean;
    header?: string;
    type: string;
    name: string;
    value?: number | string;
    error?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    resetError?: () => void;
    height?: number;
    fontSize?: string;
}
export const EditTextField: FC<EditTextFieldProps> = ({ 
    require=false, 
    header, 
    type, 
    name, 
    value, 
    error=false,
    onChange, 
    resetError,
    height, 
    fontSize 
}) => {
    return (
        <Box display='flex'>
            {
            <Box display='flex' flexDirection='column' justifyContent='center'>
                <ErrorOutline sx={{display:error ? 'block' : 'none', color:'red'}}/>
            </Box>
            }
            <TextField
                fullWidth 
                required={require}
                variant='filled'
                label={header}
                name={name}
                type={type}
                value={value}
                error={error}
                helperText={error ? header + " الزامی می باشد " : ""}
                onFocus={() => resetError}
                onChange={onChange}
                sx={{
                    "& .MuiInputLabel-root":  {
                        fontFamily: 'B Nazanin', 
                        fontSize: fontSize ? fontSize : '12px', 
                        height: 0, 
                        margin: 0, 
                        padding: 0,
                        direction: 'rtl'
                    },
                    "& .MuiFilledInput-root": {
                        fontFamily: 'B Nazanin', 
                        fontSize: fontSize ? fontSize : '12px', 
                        height: height ? height : '30px', 
                        borderBottom: error ? '1px solid red' : '0px solid grey',
                        minWidth: '97%',
                        direction: 'rtl'
                    },   
                    ".MuiFormHelperText-root": {
                        fontFamily: 'B Nazanin',
                        textAlign: 'right',
                    }
                }}
            />
        </Box>
    )
}

